import React from "react";
import { Platform } from "..";
import styled from "styled-components";
import { Body1 } from "melodies-source/Text";
import { ModalHeaderTitle } from "melodies-source/Modal";
import { useFormChangesContext } from "contexts/FormChangesContext";
import { StackedModal } from "melodies-source/StackedModal";
import { Actions, ActionsContainer } from "Components/Modal";
import { Button } from "melodies-source/Button";

interface Props {
  platform: Platform;
  isOpen: boolean;
  onClose: () => void;
}

export const ModalDelete: React.FC<Props> = ({ platform, isOpen, onClose }) => {
  const ctx = useFormChangesContext();

  const handleRemove = () => {
    platform.setValue("", "remove");
    ctx?.compareChanges(platform.id, "");
    onClose();
  };

  const header = (
    <Header>
      <ModalHeaderTitle>Remove {platform.name}</ModalHeaderTitle>
    </Header>
  );

  return (
    <StackedModal
      variant="medium"
      isOpen={isOpen}
      header={header}
      onClose={onClose}
    >
      <Info>
        Removing this code means you will no longer get data for this page on
        the platform. Add the code back at any time.
      </Info>
      <ActionsContainer>
        <Actions>
          <Button text onClick={onClose}>
            Cancel
          </Button>
          <Button type="button" onClick={handleRemove}>
            Remove
          </Button>
        </Actions>
      </ActionsContainer>
    </StackedModal>
  );
};

const Header = styled.div`
  --header-text-color: var(--main-color);
`;

const Info = styled(Body1)`
  margin-bottom: 15px;
`;
